export default __webpack_public_path__ + "static/media/pt.5995e84f.svg";